import * as React from 'react';
import { useState } from 'react';
import { Col, Row, Form, Nav, Card, Button, ListGroup, Badge, Alert, Modal, Spinner } from "react-bootstrap";
import * as yup from 'yup';
import * as formik from 'formik';
import atlasApi from "../utils/atlasapi";
import schemas from "../data/dataSchemas";


const { Formik } = formik;

class DialogBuffer extends React.Component {

	

	constructor(props) {
		super(props);
		
		this.state = {
			validated: false,
			status: {sent:null, message:''}
		}
		
		//this.owner = schemas.owner.cast(this.props.owner);
		
	}
	updateStatus(s){
		var x = {...this.state};
		x.status = s;
		this.setState(x);
		this.forceUpdate();
	}


	handleClose(data){
		this.props.onClose(data);
		this.updateStatus({sent:null, message:''});
	};
	handleOnShow(e){
		this.forceUpdate();
	};

	reset(){
		this.updateStatus({sent:null, validated:false,message:''});
		
	}
	handleSubmit(formData){

		
		this.updateStatus({sent:false, success:false, message:'Create buffer...'});

		
		var bbox = this.props.map.getBounds();



		var data = {
			...formData, 
			...{
				bounding_box : [
					bbox._sw.lng, 
					bbox._sw.lat, 
					bbox._ne.lng, 
					bbox._ne.lat,
				]
			}
		};	

			//console.log(setMainScenario);
		atlasApi.createBuffer(data, this.props.setup.layer.data.vindrId, data.buffer).then((response)=>{
			if(response.id){
				this.handleUploadComplete(response);
			}
			else if(response.error){
				this.updateStatus({sent:true, success:false, message:response.error});
				setTimeout(()=>{
					this.reset();
				}, 5000);
			}
			else
				this.updateStatus({sent:true, success:false, message:'Error creating buffer'});

		}).catch((e)=>{
			
			this.updateStatus({sent:true, success:false, message:'Error creating buffer'});
			
			setTimeout(()=>{
				this.reset();
			}, 1000);
			
		});
		//this.updateStatus({sent:false, success:false, message:'Saving...'});
		
	};
	handleUploadComplete(data){
		var self = this;
		
		if(data.id){
			this.updateStatus({sent:true, success:true, message:'The buffer was created'});
			const idx = this.props.setup.idx;
			setTimeout(()=>{
				this.reset();
				if(this.props.onBuffer){
					this.props.onBuffer(data, idx);
				}
			}, 1000);
		}
		else{
			this.updateStatus({sent:true, success:false, message:'Error uploading data'});
		}
		
	}


	render() {
		
		return (
			<Modal className={"upload-modal"} show={this.props.setup.open} onHide={(e)=>this.handleClose(e)} onShow={(e)=>this.handleOnShow(e)} centered>
				<Modal.Header>
					<Modal.Title>Add buffer on "{this.props.setup.layer?.text}"</Modal.Title>
				</Modal.Header>

				<Formik validationSchema={schemas.buffer} onSubmit={this.handleSubmit.bind(this)} initialValues={{name:this.props.setup.layer?.text+' buffered'}}>	
					{({ handleSubmit, handleChange, values, touched, errors }) => (
						<Form noValidate onSubmit={handleSubmit}>
							{this.state.status.sent === null ? (
								<React.Fragment>
									<Modal.Body>
										<Row>
											<Form.Group as={Col} md="12 mb-3" controlId="validationFormik00">
												<Form.Label className={schemas.buffer.describe().fields.name ? 'required' : ''}>Name</Form.Label>
												<Form.Control name="name" onChange={handleChange} value={values.name } placeholder="Write buffer name here" isValid={touched.name && !errors.name} isInvalid={touched.name && errors.name}/>
											</Form.Group>
										</Row>
										<Row>	
											<Form.Group as={Col} md="12" controlId="validationFormik00">
												<Form.Label className={schemas.buffer.describe().fields.buffer ? 'required' : ''}>Buffer (m) </Form.Label>
												<Form.Control name="buffer" className="w-25" onChange={handleChange} placeholder="Meters" isValid={touched.buffer && !errors.buffer} isInvalid={touched.buffer && errors.buffer}/>
											</Form.Group>
											
											<Form.Control.Feedback>
												{errors.message}
											</Form.Control.Feedback>
										</Row>
									</Modal.Body>
									
									<Modal.Footer>
										<Button className="ms-auto" variant="outline-primary" onClick={(e)=>{this.handleClose();}}>
											Cancel
										</Button>
										<Button variant="primary" type="submit">Create new buffer</Button>
									</Modal.Footer>
								</React.Fragment>
							) : (
							<Modal.Body>
								<Row className="mb-3 dialog-feedback">
									<Col xs="12" className="dialog-feedback-icon text-center">
										{
										this.state.status.sent ?
											(this.state.status.success ? 
												(<i className="ri-checkbox-circle-line text-success"></i>)
												:
												(<i className="ri-error-warning-line text-warning"></i>)
											)
											:
											(<Spinner animation="border" variant="info" className="mt-5" />)
										}
									</Col>
									<Col xs="12" className="dialog-feedback-text mb-5">
										{this.state.status.message}
									</Col>
								</Row>
							</Modal.Body>	
							)}
						</Form>
					)}	
				</Formik>
			</Modal>
		);
	}
}

export default DialogBuffer;